
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Perpignan dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Perpignan certifiée Google Partner, aide les entreprises perpignanaises à accroître leur visibilité et à acquérir de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Perpignan dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Perpignan certifiée Google Partner, aide les entreprises perpignanaises à accroître leur visibilité et à acquérir de nouveaux clients.",
        },
      ],
    };
  },
};
